import { useState, useContext, createContext } from 'react';
import PropTypes from 'prop-types';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

const HighlightMarkersContext = createContext({
  handleCardMouseEnter: () => {},
  handleCardMouseLeave: () => {},
  handleMarkerClicked: () => {},
  removeSelectedMarker: () => {},
  homecardMouseEnterId: null,
  markerClickedId: null
});

export const HighlightMarkersProvider = ({ children }) => {
  const [homecardMouseEnterId, setHomecardMouseEnterId] = useState(null);
  const [markerClickedId, setMarkerClickedId] = useState(null);

  const handleCardMouseEnter = adId => {
    setHomecardMouseEnterId(parseInt(adId, 10));
  };

  const handleCardMouseLeave = () => {
    setHomecardMouseEnterId(null);
  };

  const handleMarkerClicked = newMarkerId => {
    setMarkerClickedId(prevMarker => {
      if (prevMarker && newMarkerId === prevMarker) {
        return null;
      }
      const nextId = parseInt(newMarkerId, 10);
      SoyuzAnalytics.sendGA4Event('homecard-map-open', { item_id: nextId });
      return nextId;
    });
  };

  const removeSelectedMarker = () => {
    setMarkerClickedId(null);
  };

  return (
    <HighlightMarkersContext.Provider
      value={{
        handleCardMouseEnter,
        handleCardMouseLeave,
        handleMarkerClicked,
        removeSelectedMarker,
        homecardMouseEnterId,
        markerClickedId
      }}
    >
      {children}
    </HighlightMarkersContext.Provider>
  );
};

HighlightMarkersProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export const useHighlightMarkersContext = () =>
  useContext(HighlightMarkersContext);

export const HighlightMarkersConsumer = HighlightMarkersContext.Consumer;

export const useHomecardMouseEnterId = () => {
  const { homecardMouseEnterId } = useHighlightMarkersContext();

  return homecardMouseEnterId;
};

export const useMarkerClickedId = () => {
  const { markerClickedId } = useHighlightMarkersContext();

  return markerClickedId;
};

export default {
  HighlightMarkersProvider,
  HighlightMarkersConsumer,
  useHighlightMarkersContext,
  useHomecardMouseEnterId,
  useMarkerClickedId
};
